import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles((theme) => ({
  checkbox: {
    position: 'absolute',
  },
  checkboxLabel: {
    display: 'block',
    paddingLeft: '3.2rem !important',
  },
  dropdown: {
    width: '100%',
    position: 'relative',
    minHeight: '6.8rem',
    marginTop: '1.6rem',
  },
  dropdownDisabled: {
    opacity: 0.5,
  },
  label: {
    position: 'absolute',
    left: 0,
    top: '0',
    fontSize: '1.6rem',
    textAlign: 'left',
  },
  select: {
    height: '3.6px',
  },
  labelRequired: {
    '&:after': {
      content: '"*"',
      color: theme.colors.alert,
      marginLeft: '0.3rem',
    },
  },
  loding: {
    fontSize: 12,
    color: theme.colors.text,
    padding: '0 15px',
    textTransform: 'none',
  },
  [`@media (min-width: ${theme.mediaQueries.desktop}px)`]: {
    dropdown: (props) => ({
      width: props.widthDropdown,
      position: 'relative',
    }),
  },
}))

export default useStyles
